// extracted by mini-css-extract-plugin
module.exports = {"emptySubtitle":"TableEmptyContent_emptySubtitle__na31k"};